import { Avatar, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import SearchIcon from "@mui/icons-material/Search";
import { RateReviewOutlined } from "@mui/icons-material";
import SidebarChat from "./SidebarChat";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/userSlice";
import firestoreDB, { auth } from "../../config/firebase";

function Sidebar() {
  const user = useSelector(selectUser);
  const [chat, setChat] = useState([]);

  useEffect(() => {
    firestoreDB.collection("Chats").onSnapshot((snapshot) => {
      setChat(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
  }, []);

  const addChat = () => {
    const chatName = prompt("Please enter a chat name");
    if (chatName) {
      firestoreDB.collection("Chats").add({
        channelName: chatName,
      });
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar__header">
        <Avatar
          onClick={() => auth.signOut()}
          className="sidebar__avatar"
          src={user.photo}
        />
        <div className="sidebar__input">
          <SearchIcon />
          <input type="text" placeholder="Search" />
        </div>
        <IconButton onClick={addChat} className="sidebar__inputButton">
          <RateReviewOutlined />
        </IconButton>
      </div>
      <div className="sidebar__chats">
        {chat.map((chatData) => (
          <SidebarChat
            key={chatData.id}
            channelId={chatData.id}
            channelName={chatData.data.channelName}
          />
        ))}
      </div>
    </div>
  );
}

export default Sidebar;
